<template lang="pug">

  .btnUserCurrentPlan(v-if="!freeVersion && !!userSession === true" @click="navigateToPlans" :class="{ 'btnUserCurrentPlan--gratis': userSession.planCategory === 'free', 'btnUserCurrentPlan--bronze': userSession.planCategory === 'plano2', 'btnUserCurrentPlan--silver': userSession.planCategory === 'plano3', 'btnUserCurrentPlan--gold': userSession.planCategory === 'plano4', 'btnUserCurrentPlan--platinum': userSession.planCategory === 'plano5' }")
    div
      .btnUserCurrentPlan__arrow(:style="{ 'background-image': `url('${arrowUpgrade}')` }")
      div
        .btnUserCurrentPlan__title MEU PLANO ATUAL:
        .btnUserCurrentPlan__name {{ userSession.planName.name }}
        .btnUserCurrentPlan__text(v-if="userSession.planCategory !== 'plano5'") FAZER UPGRADE!
        .btnUserCurrentPlan__text(v-else) VEJA MAIS OPÇÕES!

</template>

<script>

  // Vuex
  import { mapState } from 'vuex'

  import { freeVersion } from '@/constants'

  import arrowUpgrade from '@/assets/upgrade-arrow.png'

  export default {
    name: 'SosCurrentPlanBadge',

    data () {
      return {
        arrowUpgrade,
        freeVersion,
      }
    },

    computed: {
      ...mapState({
        userSession: state => state.app.userSession,
      }),
    },

    /* created () {
      // [24/01/25] console.log('::: CURRENT PLAN BADGE: -> created')
    },

    mounted () {
      // [24/01/25] console.log('::: CURRENT PLAN BADGE: -> mounted')
    },

    beforeDestroy () {
      // [24/01/25] console.log('::: CURRENT PLAN BADGE: -> beforeDestroy')
    },

    unmounted () {
      // [24/01/25] console.log('::: CURRENT PLAN BADGE: -> unmounted')
    }, */

    methods: {
      navigateToPlans () {
        this.$router.push('/admin/assinatura')
      },
    },
  }

</script>
